module.exports = __webpack_public_path__ + "img/GENERAL_ADMIN.10f3bbf6.svg";